module.exports = __webpack_public_path__ + "img/JP.e2d838a2.svg";